import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output
} from '@angular/core';
import {Pagination} from '../../models/abstract/pagination.interface';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnChanges, AfterViewInit {

    @Input()
    total!: number;

    @Input()
    skip!: number;

    @Input()
    take!: number;

    @Output()
    paginationChange = new EventEmitter<Pagination>();

    showOptionalControls = true;

    constructor(private elementRef: ElementRef) {}

    ngOnChanges(): void {
        // Validate and sanitize inputs
        this.total = Math.max(0, parseInt(String(this.total), 10) || 0);
        this.skip  = Math.max(0, parseInt(String(this.skip), 10) || 0);
        this.take  = Math.max(1, parseInt(String(this.take), 10) || 10);
    }

    ngAfterViewInit(): void {
        const width = this.elementRef.nativeElement.offsetWidth;
        this.showOptionalControls = width >= 576;
    }

    onPaginationChange(paginationEvent: {skip: number, take: number}): void {
        // Validate pagination event values
        const validatedSkip = Math.max(0, parseInt(String(paginationEvent.skip), 10) || 0);
        const validatedTake = Math.max(1, parseInt(String(paginationEvent.take), 10) || 10);

        this.skip = validatedSkip;
        this.take = validatedTake;

        this.paginationChange.emit({
            total: this.total,
            skip:  this.skip,
            take:  this.take
        });
    }

}
